import template from './index.pug'

export default Vue.extend({
  name:'goodbye-page',
  template: template(),
  data() {
    return {
      web_title: Vue.store.state.webTitle
    }
  },
  watch: {
    $user: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.goToHome()
      }
    }
  }
})
